import { ApplicationController } from 'stimulus-use';

export default class extends ApplicationController {
  static targets = ['panel', 'icon'];

  connect() {
    this.start();
  }

  start() {
    this.panelTargets.forEach((panel, i) => {
      if (i === 0) {
        panel.classList.add('mt-6');
        panel.classList.add('mb-8');
        panel.style.maxHeight = `${panel.scrollHeight}px`;
        return;
      }

      panel.style.maxHeight = 0;
    });
  }

  togglePanel(e) {
    e.currentTarget.classList.toggle('active');
    const panel_index = e.currentTarget.dataset.panelIndex;
    const panel = this.panelTargets[panel_index];
    if (panel.style.maxHeight === '0px') {
      this.openPanel(panel_index);
    } else {
      this.closePanel(panel_index);
    }
  }

  openPanel(panel_index) {
    const panel = this.panelTargets[panel_index];
    panel.classList.add('mt-6');
    panel.classList.add('mb-8');
    panel.style.visibility = 'visible';
    panel.style.maxHeight = `${panel.scrollHeight}px`;
    this.iconTargets[panel_index].style.transform = 'rotate(-90deg)';
  }

  closePanel(panel_index) {
    const panel = this.panelTargets[panel_index];
    panel.classList.remove('mt-6');
    panel.classList.remove('mb-8');
    panel.style.visibility = 'hidden';
    panel.style.maxHeight = 0;
    this.iconTargets[panel_index].style.transform = '';
  }
}
